import { api } from "../../api";
import { CONF_ENDPOINTS } from "../../../constants/endpoints";

export const confApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllConf: builder.query({
      query: () => ({
        url: CONF_ENDPOINTS.GET_ALL,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: {}, // POST senza params
      }),
      providesTags: ["Conf"],
    }),

    getConfById: builder.query({
      query: (id) => ({
        url: CONF_ENDPOINTS.GET,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      }),
      providesTags: (r, e, id) => [{ type: "Conf", id }],
    }),

    createConf: builder.mutation({
      query: ({ variable, value }) => ({
        url: CONF_ENDPOINTS.CREATE,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ variable, value }),
      }),
      invalidatesTags: ["Conf"],
    }),

    updateConf: builder.mutation({
      query: ({ id, variable, value }) => ({
        url: CONF_ENDPOINTS.UPDATE,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, variable, value }),
      }),
      invalidatesTags: (r, e, { id }) => [{ type: "Conf" }, { type: "Conf", id }],
    }),

    deleteConf: builder.mutation({
      query: (id) => ({
        url: CONF_ENDPOINTS.DELETE,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      }),
      invalidatesTags: (r, e, id) => [{ type: "Conf" }, { type: "Conf", id }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAllConfQuery,
  useGetConfByIdQuery,
  useCreateConfMutation,
  useUpdateConfMutation,
  useDeleteConfMutation,
} = confApi;
